﻿import { Component, EventEmitter, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";

@Component({
    selector: "bo-builk",
    templateUrl: "./builk.component.html",
    styleUrls: ["./builk.component.scss"]
})

export class BuilkComponent implements OnInit {

    isToggle: boolean = false;
    main: string = "main-container";

    constructor(
        private router: Router
    ) {  }

    ngOnInit(): void {

        // Redirect to Dashboard
        const tempRoute = this.router.url;
        if (tempRoute === "/builk/" || tempRoute === "/builk") {
            this.router.navigate(["/builk/dashboard"]);
        }
    }

    toggleSidebar(event: boolean): void {
        this.isToggle = event;

        // css main
        if (this.isToggle) {
            this.main = "toggle-main-container";
        } else {
            this.main = "main-container";
        }
    }
}
